<div class="pointer">
	<div class="avatar" [ngStyle]="{ 'background-image': getUserAvatar() }" (click)="showMenuPanel()"
		nbTooltip="{{ 'SIDEBAR.TUSDATOS' | translate }}" nbTooltipPlacement="right">
		<div *ngIf="actualProfile == 'ESTUDIANTE'" class="status-icon-student"></div>
		<div *ngIf="actualProfile == 'PROFESOR'" class="status-icon-teacher"></div>
		<div *ngIf="actualProfile == 'PADRE'" class="status-icon-parent"></div>
		<div *ngIf="actualProfile == 'AUTOR'" class="status-icon-editor"></div>
		<div *ngIf="actualProfile == 'ADMIN'" class="status-icon-admin"></div>
		<div *ngIf="actualProfile == 'CENTRO'" class="status-icon-center"></div>
		<div *ngIf="actualProfile == 'COMERCIAL'" class="status-icon-comercial"></div>
	</div>
	<div *ngIf="showUserAccount">
		<nb-card class="menu-card">
			<nb-card-body class="p-0">
				<div class="d-flex flex-column gap-2 px-4 py-3">
					<span class="m-0 texto-pequeno">{{ user.firstName }}</span>
					<p class="userId m-0 texto-pequeno">ID: {{ user.identification }}</p>
					<!-- BOTON PARA VER LOS TUTORIALES -->
					<button nbButton status="primary" size="small" (click)="onToggleTutorialChange()" *ngIf="!isMobile"
						[ngClass]="{'disabledBtnTutorial': !tutorialesActivos}">
						Tutoriales
						<img src="../../../../../assets/images/icons/youtube-menu.webp" width="22" class="ml-2">
					</button>
				</div>

				<nb-list *ngIf="profilesOfUser">
					<nb-list-item (click)="firstStepStudent()" *ngIf="profilesOfUser.profileStudent == true"
						[ngClass]="{ 'active-menu-item': userSelectedProfile == 'ESTUDIANTE' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-student"></div>
						</div>
						<span class="texto-pequeno">{{ "LOGIN.STUDENT" | translate }}</span>
					</nb-list-item>
				<nb-list-item (click)="setProfile(profiles.Teacher, true, true)"
					*ngIf="profilesOfUser.profileTeacher == true && !isMobile"
					[ngClass]="{ 'active-menu-item': userSelectedProfile == 'PROFESOR' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-teacher"></div>
						</div>
						<span class="texto-pequeno">{{ "LOGIN.TEACHER" | translate }}</span>
					</nb-list-item>
					<nb-list-item (click)="showControlPanelParent()"
						*ngIf="profilesOfUser.profileParent == true && !isMobile"
						[ngClass]="{ 'active-menu-item': userSelectedProfile == 'PADRE' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-parent"></div>
						</div>
						<span class="texto-pequeno">{{ "LOGIN.PARENT" | translate }}</span>
					</nb-list-item>
				<nb-list-item (click)="setProfile(profiles.Author, true, true)"
					*ngIf="profilesOfUser.profileEditor == true && !isMobile"
					[ngClass]="{ 'active-menu-item': userSelectedProfile == 'AUTOR' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-editor"></div>
						</div>
						<span class="texto-pequeno">{{ "LOGIN.EDITOR" | translate }}</span>
					</nb-list-item>
					<nb-list-item (click)="showControlPanel()" *ngIf="profilesOfUser.profileCenter == true && !isMobile"
						[ngClass]="{ 'active-menu-item': userSelectedProfile == 'CENTRO' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-center"></div>
						</div>
						<span class="texto-pequeno">{{ "LOGIN.CENTER" | translate }}</span>
					</nb-list-item>
					<nb-list-item (click)="showControlPanelComercial()"
						*ngIf="profilesOfUser.profileComercial == true && !isMobile"
						[ngClass]="{ 'active-menu-item': actualProfile == 'COMERCIAL' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-comercial"></div>
						</div>
						<span class="texto-pequeno">Comercial</span>
					</nb-list-item>
					<nb-list-item (click)="showControlPanelAdmin()"
						*ngIf="profilesOfUser.profileAdmin == true && !isMobile"
						[ngClass]="{ 'active-menu-item': userSelectedProfile == 'ADMIN' }" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-admin"></div>
						</div>
						<span class="texto-pequeno">{{ "Admin" }}</span>
					</nb-list-item>
					<nb-list-item (click)="showGeneralSettings()" class="gap-3" *ngIf="!isMobile">
						<div class="d-flex">
							<div class="menu-icon-settings"></div>
						</div>
						<span class="texto-pequeno">{{ "SETTINGS.GENERALTITLE" | translate }}</span>
					</nb-list-item>


					<!-- <nb-list-item (click)="showChatAssistant()"
						class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-settings"></div>
						</div>
						<div>Asistente IA</div>
					</nb-list-item> -->

					<!-- <nb-list-item
					(click)="sos()"
					class="gap-3"
				>
					<div class="d-flex">
						<nb-icon icon="video-outline" class="mr-2"></nb-icon>
					</div>
					<div>SOS</div>
				</nb-list-item> -->

					<nb-list-item (click)="logout()" class="gap-3">
						<div class="d-flex">
							<div class="menu-icon-power"></div>
						</div>
						<span class="texto-pequeno">{{ "SIDEBAR.LOGOUT" | translate }}</span>
					</nb-list-item>
				</nb-list>
			</nb-card-body>
		</nb-card>
	</div>
</div>